<template>
  <div class="myinfo">
    <div class="choosetopic">
      <h1><span></span>论文选题</h1>
      <table class="table table-bordered" v-if="!titleId && !teacherId">
        <tr>
          <th style="width: 8%">序号</th>
          <th style="width: 77%">论文题目</th>
          <th style="width: 15%">操作</th>
        </tr>
        <tr v-for="(item, index) in titleIds" :key="index">
          <td>{{ index + 1 }}</td>
          <td class="topicname">{{ item.title }}</td>
          <td>
            <router-link
              :to="`/graduationManagement/changestatefirsttopic?index=${index}`"
              ><button class="btn bnt-success">进入选题</button></router-link
            >
          </td>
        </tr>
      </table>
      <div v-else class="chooseresault">
        <div class="">您已选择论文和指导老师</div>
        <div>选择的论文：<span class="bgcolor">{{title}}</span></div>
        <div>选择的指导老师：<span class="bgcolor">{{teacher}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "@/common/components/Header";
import Foot from "@/common/components/Foot";
import PersonalCenter from "@/common/components/PersonalCenter";
export default {
  name: "ChangeStateFirst",
  components: {
    PersonalCenter,
    HomeHeader,
    Foot,
  },
  data: function () {
    return {
      titleIds: null,
      teacherIds: null,
      teacherId: null,
      titleId: null,
      title: null,
      teacher: null,
      titleName:null
    };
  },
  mounted() {
    this.getThesis();
  },
  methods: {
    getThesis() {
      this.axios.get(`/biz/thesis/time`).then((res) => {
        if (res.success) {
          this.titleIds = res.result.titleIds;
          this.teacherIds = res.result.teacherIds;
          this.teacherId = res.result.teacherId;
          this.titleId = res.result.titleId;
          this.teacher = res.result.teacherName;
          this.titleName = res.result.titleName;
          if (this.teacherId && this.titleId) {
            this.titleIds.forEach((element) => {
              if (element.id === this.titleId) {
                this.title = element.title;
              }
            });
            this.teacherIds.forEach((element) => {
              if (element.id === this.teacherId) {
                this.teacher = element.name;
              }
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

h1 {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;

  span {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: $bgColor;
    margin-right: 10px;
  }
}

.myinfo {
  .page-width {
    width: $pageWidth;
    margin: 0 auto;
    margin-top: 20px;
    margiin-bottom: 30px;
  }

  .choosetopic {
    background: #fff;
    padding: 28px;
  }
}

.download {
  span {
    margin-right: 30px;

    a {
      color: $bgColor;
      text-decoration: underline;
    }
  }
}

.btn-info {
  background: $bgColor;
}

.info {
  line-height: 30px;

  span {
    font-weight: bold;
  }
}

.back {
  color: $bgColor;
}

th {
  text-align: center;
  background: #f6f6f8;
}

td {
  text-align: center;
}

.topicname {
  text-align: left;
}

.buttonbg {
  background: $bgcontent;
  padding: 10px 20px;
  margin-bottom: 20px;
}

.bnt-success {
  padding: 0;
  background: $bgColor;
  color: #fff;
}
  .chooseresault{
    line-height:32px;
    .bgcolor{
      color:$bgColor;
      font-weight:bold;
    }
    color:#999;
  }
</style>



// WEBPACK FOOTER //
// src/pages/graduationmanagement/components/ChangeStatefirst.vue